import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DialogInfoMessageComponent } from '../conmponents/dialog-info-message/dialog-info-message.component';
import { SnackBarMessageErrorComponent } from '../conmponents/snack-bar-message-error/snack-bar-message-error.component';
import { SnackBarMessageSuccessComponent } from '../conmponents/snack-bar-message-success/snack-bar-message-success.component';
import { SnackBarMessageWarningComponent } from '../conmponents/snack-bar-message-warning/snack-bar-message-warning.component';

@Injectable()
export class InfoMessagesService {
  private dialogRef!: MatDialogRef<any>;

  constructor(
    private readonly snackBar: MatSnackBar,
    private readonly dialog: MatDialog,
  ) {}

  closeDialog() {
    this.dialogRef?.close();
  }

  public showSuccess(message: string) {
    this.snackBar.openFromComponent(SnackBarMessageSuccessComponent, {
      panelClass: ['snack-bar-action-message', 'info-success-panel'],
      data: message,
    });
  }

  public showWarning(message: string) {
    this.snackBar.openFromComponent(SnackBarMessageWarningComponent, {
      panelClass: ['snack-bar-action-message', 'info-warning-panel'],
      data: message,
    });
  }

  public showError(message: string) {
    this.snackBar.openFromComponent(SnackBarMessageErrorComponent, {
      panelClass: ['snack-bar-action-message', 'info-error-panel'],
      data: message,
    });
  }

  public showMessagePopup(title: string, message: string) {
    this.dialogRef = this.dialog.open(DialogInfoMessageComponent, { data: { title, message }, maxWidth: '560px' });

    return this.dialogRef.afterClosed();
  }
}
